import { render, staticRenderFns } from "./WizardHome.vue?vue&type=template&id=c35fb384"
import script from "./WizardHome.vue?vue&type=script&lang=ts"
export * from "./WizardHome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports